module.exports = __webpack_public_path__ + "img/banner-UFC.9ec51e53.jpg";